module.exports = __webpack_public_path__ + "jab/media/warning.ace0514a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/warning.svg
// module id = 1482
// module chunks = 0